import {Theme} from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export const styles = (theme: Theme) =>
  createStyles({
    orderContainer: {
      flexDirection: 'row',
    },
    orderControlLabelRoot: {
      marginBottom: '0',
    },
    orderControlLabel: {
      fontSize: 14,
    },
  });

export type Styles = WithStyles<typeof styles>;
